module.exports = __webpack_public_path__ + "img/icon-srp.7b9ca723.png";